import Box from "@mui/material/Box"
import type { FC } from "react"

import colors from "@/styles/colors"

interface Props {
  label: string | undefined
  backgroundColor: string | undefined
}

export const ColoredLabel: FC<Props> = ({ label = "-", backgroundColor = colors.tertiary.green["100"] }) => {
  return (
    <Box className='inline-flex items-center rounded-[2px] px-[16px] py-[4px]' sx={{ backgroundColor }}>
      {label}
    </Box>
  )
}
